import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[adHost]',
    standalone: false
})
export class HostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
